import { PlayerAvatar } from "./PlayerAvatar";
import { CurrentPlayerAvatar } from "./CurrentPlayerAvatar";

export { PlayerAvatar, CurrentPlayerAvatar };
